import * as React from 'react';
import Component from '../../Component';
import Item from './Item';
import Error from '../../Components/Error';
import { STATUS } from '../../General';

export default class List extends Component {

    render() {
        const leaveTypes = this.props.leaveTypes;
        switch (leaveTypes.status) {
            case STATUS.LOADING:
                return this.renderLoading();
            case STATUS.READY: {
                if (leaveTypes.arr.length === 0) {
                    const t = this.translate();
                    return (
                        <div className="col-12 text-danger mb-3">
                            {t('no.leave.types.found')}
                        </div>
                    );
                }
                return leaveTypes.arr.map((leaveType: any) => {
                    return (
                        <div
                            key={'LeaveTypes' + this.props.viewMode + '-' + leaveType.id}
                            className={this.getListColSize(this.props.viewMode) + ' mb-3'}
                        >
                            <Item leaveType={leaveType} />
                        </div>
                    );
                });
            }
            default:
                return (<Error />);
        }
    }
}